export default {
  hoursPerDate: 'HOURS_PER_DATE',
};
